import { Skeleton, useToast } from '@chakra-ui/react';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import _ from 'lodash';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { Organization } from '@finley-technologies/finley-types';

import { useGetUserActiveCreditFacilitiesQuery } from 'types/dashboard-core-gqlTypes.generated.d';

import { errorToastConfig } from 'packages/common-frontend/constants';
import { useGetLedgerAccountsQuery } from 'packages/statements/requests/ledger.gql.generated';
import { OutstandingLedgerTableContainer } from 'packages/statements/ui/OutstandingLedgerViewContainer';

export const PortfolioStatementsOutstandingLedgerContainer: React.FC<{
  creditFacilityId: string;
}> = withLDConsumer()(({ flags, creditFacilityId }) => {
  const toast = useToast();
  const history = useHistory();

  const { data: userData } = useGetUserActiveCreditFacilitiesQuery({
    variables: {
      creditFacilitySlugsToHide: flags?.creditFacilitySlugsToHide ?? [],
    },
  });
  const {
    data: ledgerAccountTypesData,
    loading: isLedgerAccountTypesLoading,
  } = useGetLedgerAccountsQuery({
    variables: {
      creditFacilityId,
      ledgerAccountGroup: 'outstandingLedger',
    },
  });
  if (
    !userData ||
    !userData.user ||
    !ledgerAccountTypesData ||
    isLedgerAccountTypesLoading
  ) {
    return (
      <Skeleton
        data-testid="loading-portfolio-statements-outstanding-ledger"
        height="600px"
      />
    );
  }

  const {
    user: {
      organizationId,
      organization: { slug, name, industry, creditFacilities },
    },
  } = userData;

  const userOrganization = {
    id: organizationId,
    slug,
    name,
    industry,
    type: Organization.OrganizationType.CapitalProvider,
  };

  const creditFacilitySlug = _.find(
    creditFacilities,
    ({ id }) => id === creditFacilityId,
  )?.slug;

  if (!creditFacilityId || !creditFacilitySlug) {
    history.push('/portfolio/overview/facilities');
    toast({
      ...errorToastConfig,
      id: 'errorLoadPortfolioStatementsExpensesFeesNoCreditFacility',
      title: 'Please select a credit facility.',
    });
    return null;
  }

  const allAccountTypes = _.uniq(
    _.map(ledgerAccountTypesData.ledgerAccounts, 'tAccount'),
  );

  return (
    <OutstandingLedgerTableContainer
      accountTypes={allAccountTypes}
      capitalProviders={[userOrganization]}
      creditFacilityId={creditFacilityId}
    />
  );
});
